import type { QuoteState, Quote } from '../../vendor-dashboard/types/quote';

const selectors = {
    getQuotes: ( state: QuoteState, queryParams = {} ): Quote[] => {
        return state.quotes || [];
    },

    getQuote: ( state: QuoteState, id: number ): Quote | null => {
        return state.quote;
    },

    getHeaders: ( state: QuoteState ): Record< string, any > => {
        return state.headers;
    },

    getParentQuotes: ( state: QuoteState ): Quote[] => {
        return state.parents;
    },

    getLoading: ( state: QuoteState ): boolean => {
        return state.loading;
    },
};

export default selectors;
